import cx from "classnames";

import { MINUTE_IN_MILLISECONDS } from "@util/getElapsedTime";

import { EyebrowProps } from "./types";

import styles from "./styles.module.css";

export enum Theme {
  "opinion-blue" = "opinion-blue",
  "red" = "red",
}

export const Duration = ({
  timeInMilliseconds,
  prefix,
}: {
  timeInMilliseconds: number;
  prefix: string;
}) => (
  <time className={styles.duration}>
    {prefix} ({Math.floor(timeInMilliseconds / MINUTE_IN_MILLISECONDS) % 60}:
    {(Math.floor(timeInMilliseconds / 1000) % 60).toString().padStart(2, "0")})
  </time>
);

Duration.displayName = "Eyebrow.Duration";

export function Component(props: EyebrowProps) {
  const { duration, text, url: _url } = props;

  if (!text && !duration) {
    console.error(`<Eyebrow /> cannot render without text or duration`);

    return null;
  }

  return (
    <div className={cx(styles.eyebrowContainer)}>
      {duration && <Duration {...duration} />}
      {text && !duration && text}
    </div>
  );
}
Component.displayName = "Eyebrow.Component";
